import { useTranslation } from '@frontend/i18n';
import {
  Button,
  ModalControlTriggerProps,
  SearchField,
  useDebouncedValue,
  useDidUpdate,
  useFormField,
} from '@frontend/design-system';
import { BulkCreateStepId } from '../../BulkCreateModal/bulk-create-modal';
import { BULK_CREATE_STEPS } from '../../BulkCreateModal/bulk-create-steps-key-title';
import { styles } from '../styles';

type DesktopToolBarProps = {
  selected: string[];
  triggerProps: ModalControlTriggerProps;
  onSearchChange: (value: string) => void;
  toggleInitialStep: (stepId: BulkCreateStepId) => void;
  searchText: string;
};
export const DesktopToolBar = ({
  selected,
  triggerProps,
  onSearchChange,
  toggleInitialStep,
  searchText,
}: DesktopToolBarProps) => {
  const { t } = useTranslation('payments');
  const globalSearch = useFormField({ type: 'text', value: searchText }, []);
  const debouncedValue = useDebouncedValue(globalSearch.value, 300);

  useDidUpdate(() => {
    onSearchChange(debouncedValue);
  }, [debouncedValue]);

  return (
    <div css={styles.topToolbarDesktop.container}>
      {!!selected.length && (
        <Button
          {...triggerProps}
          variant='secondary'
          iconName='payment-request'
          css={styles.topToolbarDesktop.button}
          trackingId='bulk-collections-send-sms-button-from-desktop-list'
          onClick={() => {
            toggleInitialStep(BULK_CREATE_STEPS.SEND_SMS.id);
            triggerProps.onClick?.();
          }}
        >
          {t('Text-to-Pay')}
        </Button>
      )}
      <div css={styles.topToolbarDesktop.actionsContainer}>
        <SearchField
          placeholder={'Search'}
          name='Global Table Search'
          data-trackingid={'tableTrackingIds.globalSearch'}
          {...globalSearch}
        />
      </div>
    </div>
  );
};
